import {useTranslation} from "react-i18next";
import Box from "@mui/material/Box";
import ErrorsCatcher from "@/components/ErrorsCatcher/Tsx/ErrorsCatcher";
import CreateOrEditFileMeaningDialog
    from "@/features/InControlPanel/ReferenceBooks/LaboratoryClarifications/FileMeanings/CreateOrEditFileMeaningDialog";
import {useDispatch, useSelector} from "react-redux";
import ConfirmDeleteDialog from "@/features/InControlPanel/ReferenceBooks/ui/ConfirmDeleteDialog/ConfirmDeleteDialog";
import {showPopup} from "@/features/PopupMessages/PopupMessages";
import {useDeleteFileMeaningMutation} from "@/api/ReferenceBooks/Lists/LaboratoryClarifications/FileMeanings/Delete/DeleteFileMeaningsApiSlice";
import {
    FileMeaningsSelectors,
    reset
} from "@/features/InControlPanel/ReferenceBooks/LaboratoryClarifications/FileMeanings/Slice/FileMeaningsSlice";
import FileMeaningTable from "@/features/InControlPanel/ReferenceBooks/LaboratoryClarifications/FileMeanings/FileMeaningTable";

function FileMeaningsContent() {
    const {t} = useTranslation();

    const dispatch = useDispatch();

    const isDeleteModalVisible = useSelector(FileMeaningsSelectors.deleteModalVisible)
    const [deleteFileMeaning, {isLoading: isDeleting}] = useDeleteFileMeaningMutation()
    const deleteId = useSelector(FileMeaningsSelectors.deleteId)

    return (
      <>
          <Box sx={{mt: 2}}>
              <ErrorsCatcher errorId="a9fdcd48-2a74-4609-b283-d36cca10309c">
                  <CreateOrEditFileMeaningDialog/>
              </ErrorsCatcher>
          </Box>

          <Box sx={{mt: 2,}}>
              <ErrorsCatcher errorId="cacc8853-3a25-4df8-97d2-b001c00dc028">
                  <FileMeaningTable/>
              </ErrorsCatcher>
          </Box>

          <ConfirmDeleteDialog
            isDeleteModalVisible={isDeleteModalVisible}
            isDeleting={isDeleting}
            handleCloseDeleteModal={handleCloseDeleteModal}
            handleDelete={handleDelete}
            title={t("Deleting file meaning")}
            message={t("Are you sure you want to delete file meaning") + " №" + deleteId}
          />
      </>
    );

    async function handleDelete() {
        if (!deleteId) {
            showPopup({
                type: "error",
                message: t("An error occured during the request."),
                autoClose: 5000
            })
        } else {
            try {
                const response = await deleteFileMeaning(deleteId).unwrap()

                showPopup({
                    type: "success",
                    message: t("The request performed successfully."),
                    autoClose: 5000,
                });
            } catch (e) {
                showPopup({
                    type: "error",
                    message: t("An error occured during the request."),
                });
            }
            dispatch(reset())
        }
    }

    function handleCloseDeleteModal() {
        dispatch(reset())
    }
}

export default FileMeaningsContent;
